import { $elementChild, $elementChildren } from "@common/helpers/elements";

function init($views) {
	const ACTIVE_CLASS = "active";
	const ANIMATION_DURATION = 300;

	$views.forEach(($view) => {
		let index = 0;
		const $next = $elementChild($view, "navigation-next");
		const $prev = $elementChild($view, "navigation-prev");
		const $more = $elementChild($view, "navigation-more");
		const $slides = $elementChildren($view, "slide");

		function buttons() {
			$prev.disabled = index === 0;
			$next.disabled = index === $slides.length - 1;
		}

		function showChildren() {
			if ($slides.length > 0) {
				$elementChildren($slides[index], "card").forEach(($card, i) => setTimeout(() => $card.classList.add(ACTIVE_CLASS), ANIMATION_DURATION * i));
			}
		}

		function hideChildren() {
			$elementChildren($slides[index], "card").forEach(($card, i) => setTimeout(() => $card.classList.remove(ACTIVE_CLASS), ANIMATION_DURATION * i));
		}

		function activate() {
			$slides.forEach(($slide) => $slide.classList.remove(ACTIVE_CLASS));
			$slides[index].classList.add(ACTIVE_CLASS);
			buttons();
		}

		function next() {
			if (index < $slides.length - 1) {
				hideChildren();
				index++;
				activate();
				showChildren();
			}
		}

		function prev() {
			if (index > 0) {
				hideChildren();
				index--;
				activate();
				showChildren();
			}
		}

		function slide(direction) {
			direction();
		}

		$next.addEventListener("click", () => {
			slide(next);
		});

		$prev.addEventListener("click", () => {
			slide(prev);
		});

		$more.addEventListener("click", () => {
			if (index < $slides.length - 1) {
				$slides[++index].classList.add(ACTIVE_CLASS);
			}

			$more.disabled = index === $slides.length - 1;
		});

		showChildren();
		buttons();
	});
}

export default {
	view: "immersive-template-carousel",
	init,
};
